export enum RELEASED_DOCUMENT_TYPE {
  CARTA_DI_IDENTITA_IE = 'IE',
  STATO_CIVILE = 'SC',
  CARTA_DI_IDENTITA_ID = 'ID',
}

export enum PAYMENT_TYPE {
  POS = 'P',
  CASH = 'C',
  ABSENT = 'E',
}
